import React from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import type {
  MemberInfo,
} from '../types/member.types';

import {
  formatDate,
  formatNumber,
} from '../../../shared/utils/formatUtils';

import StatusBadge from './StatusBadge';

import RouteConfig from '../../../routes/RouteConfig';

type Props = {
  users: MemberInfo[];

  hasActiveFilter:
    boolean;

  onActivate:
    (
      userId: string,
    ) => Promise<void>;

  onDeactivate:
    (
      userId: string,
    ) => Promise<void>;
};

const MemberMobileList:
  React.FC<Props> = ({
    users,
    hasActiveFilter,
    onActivate,
    onDeactivate,
  }) => {
  const navigate =
    useNavigate();

  if (
    users.length === 0
  ) {
    return (
      <div className="flex min-h-56 items-center justify-center rounded-xl border border-gray-200 bg-white px-6 py-12 text-center text-sm text-gray-500">
        {hasActiveFilter
          ? '검색 결과가 없습니다'
          : '등록된 회원이 없습니다'}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {users.map(
        (user) => (
          <article
            key={
              user.id
            }
            className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
          >
            <button
              type="button"
              onClick={() =>
                navigate(
                  RouteConfig
                    .Management
                    .MemberDetail
                    .to(
                      user.userId,
                    ),
                )
              }
              className="block w-full px-4 pb-3 pt-4 text-left"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="break-words text-base font-semibold text-gray-900">
                    {
                      user.userName
                    }

                    {user.userNickname
                      ? ` (${user.userNickname})`
                      : ''}
                  </p>

                  <p className="mt-1 truncate text-sm text-gray-500">
                    #
                    {
                      user.userId
                    }
                  </p>
                </div>

                <StatusBadge
                  status={
                    user.status
                  }
                />
              </div>
            </button>

            <div className="grid grid-cols-2 gap-x-4 gap-y-3 border-y border-gray-100 bg-gray-50/70 px-4 py-3">
              <div>
                <p className="text-xs text-gray-500">
                  라포이트 시드
                </p>

                <p className="mt-1 text-sm font-medium text-gray-900">
                  {formatNumber(
                    user.point ??
                      0,
                  )}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">
                  매장포인트
                </p>

                <p className="mt-1 text-sm font-medium text-gray-900">
                  {formatNumber(
                    user.storePoint ??
                      0,
                  )}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">
                  연락처
                </p>

                <p className="mt-1 text-sm text-gray-700">
                  {user.phoneNumber ??
                    '-'}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">
                  가입일
                </p>

                <p className="mt-1 text-sm text-gray-700">
                  {formatDate(
                    user.createAt,
                  )}
                </p>
              </div>
            </div>

            <div className="flex justify-end px-4 py-3">
              {user.status ===
              'ACTIVE' ? (
                <button
                  type="button"
                  onClick={() =>
                    void onDeactivate(
                      user.userId,
                    )
                  }
                  className="inline-flex min-h-9 items-center justify-center rounded-lg bg-red-500 px-3 py-2 text-sm font-medium text-white hover:bg-red-600"
                >
                  비활성화
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() =>
                    void onActivate(
                      user.userId,
                    )
                  }
                  className="inline-flex min-h-9 items-center justify-center rounded-lg bg-green-500 px-3 py-2 text-sm font-medium text-white hover:bg-green-600"
                >
                  {user.status ===
                  'PENDING'
                    ? '승인'
                    : '활성화'}
                </button>
              )}
            </div>
          </article>
        ),
      )}
    </div>
  );
};

export default MemberMobileList;